import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import {Calendar} from 'primereact/calendar';

export function PickDateRange(props) {
    // Ensure `iDate` is always valid; fallback to a default or current date
    const parsedIDate = dayjs(props.dates[0], 'DD/MM/YYYY');
    const validInitDate = parsedIDate.isValid() ? parsedIDate.toDate() : null;
    const parsedFDate = dayjs(props.dates[1], 'DD/MM/YYYY');
    const validFinalDate = parsedFDate.isValid() ? parsedFDate.toDate() : null;
    const [dates, setDates] = React.useState(null);
    const handleHide = () => {
        props.setDates(dates)
    }
    useEffect(() => {
        setDates(props.dates)
    },[props.dates])

    return (
        <>

                <Calendar value={dates} onChange={(e)=>{setDates(e.value)}} selectionMode="range" readOnlyInput
                          dateFormat="dd/mm/yy"
                          disabled={props.disable}
                          style={{fontSize: '1vw'}}
                          onHide={handleHide}
                          className="flex ml-1 w-full h-2rem  align-items-center" showIcon
                          hideOnRangeSelection
                />

        </>
    );
}


PickDateRange.propTypes = {
    dates: PropTypes.array.isRequired,
    setDates: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,
};
